/* TASK 84(3) — guarantee-sync: η «Επέκταση εγγύησης» ΔΕΝ μένει ποτέ ορφανή στο
   καλάθι — αν αφαιρεθεί κάθε προϊόν-γονέας (product type = trigger, π.χ. Ρολόι),
   οι γραμμές εγγύησης αφαιρούνται αυτόματα.
   + K2C Item-3 (Σ07-30) → Α10 (Σ07-31, owner-ΟΡΙΣΤΙΚΟ): η αφαίρεση = ΑΚΑΡΙΑΙΑ
   (optimistic hide των DOM γραμμών [data-key] ΠΡΙΝ ολοκληρωθεί το δίκτυο),
   ΧΩΡΙΣ κανένα μήνυμα — το showNote/msg-path καταργήθηκε ολόκληρο.
   Πρότυπο: engraving-sync/monopetro-sync (ξεχωριστό μικρό αρχείο — το ιερό
   cart.js ΔΕΝ αγγίζεται· μηδέν επαφή με engraving/fee μηχανισμούς). Config από
   το [data-guarantee-desired] island του cart-drawer section.
   Fail-open: χωρίς config / σφάλμα δικτύου → καμία ενέργεια. */
(function () {
  'use strict';
  var syncing = false;
  var disabled = false;

  function readCfg() {
    var el = document.querySelector('[data-guarantee-desired]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  /* K2C Item-3: ακαριαίο κρύψιμο των γραμμών εγγύησης στο DOM (πριν το δίκτυο) */
  function hideLines(keys) {
    keys.forEach(function (k) {
      document.querySelectorAll('[data-key="' + k + '"]').forEach(function (el) {
        el.hidden = true;
      });
    });
  }

  function refreshDrawer() {
    return fetch(window.location.pathname + '?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var dialog = document.querySelector('[data-cart-drawer]');
        if (dialog && data['cart-drawer']) {
          var tmp = document.createElement('div');
          tmp.innerHTML = data['cart-drawer'];
          dialog.firstElementChild.innerHTML = tmp.firstElementChild.innerHTML;
        }
        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
        });
      });
  }

  /* Σ08-01 owner-QA issue-2: το «ακαριαίο» περνούσε πρώτα από GET /cart.js
     (ορατή καθυστέρηση δευτερολέπτων). Τώρα η απόφαση παίρνεται από το DOM
     (data-ptype/data-phandle του drawer, Liquid-τυπωμένα) ΧΩΡΙΣ δίκτυο — το
     fetch-μονοπάτι ακολουθεί ως αυθεντία για την πραγματική αφαίρεση.
     Fail-open: χωρίς τα attributes (παλιό markup) → ισχύει μόνο το παλιό path. */
  function domInstantHide(cfg) {
    var lines = document.querySelectorAll('[data-key][data-ptype]');
    if (!lines.length) return;
    var gKeys = [];
    var hasParent = false;
    lines.forEach(function (el) {
      if (el.getAttribute('data-phandle') === cfg.gh || el.getAttribute('data-ptype') === 'guarantee') {
        gKeys.push(el.getAttribute('data-key'));
      } else if (cfg.tt && el.getAttribute('data-ptype') === cfg.tt) {
        hasParent = true;
      }
    });
    if (gKeys.length && !hasParent) hideLines(gKeys);
  }

  function sync() {
    if (syncing || disabled) return;
    var cfg = readCfg();
    if (!cfg || !cfg.gh) return;
    domInstantHide(cfg);
    syncing = true;
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var guaranteeKeys = [];
        var hasParent = false;
        (cart.items || []).forEach(function (it) {
          /* ίδια κριτήρια με το liquid του drawer: handle ή type 'guarantee' */
          if (it.handle === cfg.gh || it.product_type === 'guarantee') {
            guaranteeKeys.push(it.key);
          } else if (cfg.tt && it.product_type === cfg.tt) {
            hasParent = true;
          }
        });
        if (!guaranteeKeys.length || hasParent) { syncing = false; return; }
        /* ΑΚΑΡΙΑΙΑ: κρύψε τις γραμμές ΤΩΡΑ — το δίκτυο ακολουθεί, κανένα μήνυμα (Α10) */
        hideLines(guaranteeKeys);
        var updates = {};
        guaranteeKeys.forEach(function (k) { updates[k] = 0; });
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates }),
        }).then(function (r) {
          if (!r.ok) throw new Error('update failed');
          /* Σ08-01: στη ΣΕΛΙΔΑ καλαθιού (reload-pattern, βλ. cart.liquid qty-flow)
             τα σύνολα διορθώνονται με reload — η γραμμή είναι ήδη κρυμμένη (0 flash) */
          if (document.querySelector('.cart-page__items')) { window.location.reload(); return; }
          return refreshDrawer();
        }).then(function () {
          syncing = false;
        });
      })
      .catch(function () { disabled = true; syncing = false; });
  }

  /* Σ08-01β (owner iPhone-QA): η αφαίρεση ΓΟΝΕΑ άφηνε την εγγύηση ορατή ~1s —
     το κρύψιμο έτρεχε μόνο στο cart:updated, δηλαδή ΜΕΤΑ τα 2 network round-trips
     του cart.js (change.js + section re-render). Τώρα η απόφαση παίρνεται την ώρα
     του ΚΛΙΚ (capture phase — πριν τρέξει οποιοσδήποτε handler), από το DOM μόνο.
     Καλύπτει: drawer ✕ [data-remove-line] · drawer «−» σε qty 1 · drawer input→0 ·
     /cart ✕ link (full navigation — το κρύψιμο προλαβαίνει το unload).
     Το cart:updated δίχτυ παραμένει η αυθεντία: αν το δίκτυο αποτύχει, το επόμενο
     re-render ξαναδείχνει την αλήθεια του server (self-healing, fail-open). */
  function parentRemovalInstantHide(clickedLine) {
    var cfg = readCfg();
    if (!cfg || !cfg.gh || !cfg.tt) return;
    if (clickedLine.getAttribute('data-ptype') !== cfg.tt) return;
    var key = clickedLine.getAttribute('data-key');
    var gKeys = [];
    var otherParent = false;
    document.querySelectorAll('[data-key][data-ptype]').forEach(function (el) {
      if (el.hidden) return;
      if (el.getAttribute('data-phandle') === cfg.gh || el.getAttribute('data-ptype') === 'guarantee') {
        gKeys.push(el.getAttribute('data-key'));
      } else if (el.getAttribute('data-ptype') === cfg.tt && el.getAttribute('data-key') !== key) {
        otherParent = true; /* μένει άλλος γονέας (σύγκριση σε key — drawer+page διπλότυπα ίδιου key δεν μετράνε) */
      }
    });
    if (gKeys.length && !otherParent) hideLines(gKeys);
  }

  /* Σ08-01γ (owner: «3 σκαλοπάτια — εγγύηση, μετά ρολόι, μετά μπάρα»): η ρίζα
     είναι αρχιτεκτονική — γονέας και εγγύηση έφευγαν σε ΔΥΟ σειριακά δίκτυα +
     2 re-renders. Λύση = το αποδεδειγμένο fee-batch pattern του Σ07-13 («η
     χρέωση αργεί να φύγει», ΙΔΙΟ παράπονο): στην αφαίρεση του ΤΕΛΕΥΤΑΙΟΥ γονέα
     αναλαμβάνουμε ΕΜΕΙΣ (capture + stopPropagation πριν το ιερό cart.js):
     γονέας + εγγύηση κρύβονται ΜΑΖΙ ακαριαία και φεύγουν με ΕΝΑ /cart/update.js
     → ΕΝΑ re-render (σύνολα+μπάρα μαζί). Το cart.js ΔΕΝ αγγίζεται — απλώς δεν
     ακούει αυτό το ένα κλικ. Αν ο γονέας χρωστά χρέωση χαράγματος → ΔΕΝ
     αναλαμβάνουμε (το fee-batch του cart.js ξέρει καλύτερα)· fail-open: σε
     σφάλμα δικτύου γίνεται refresh/reload = η αλήθεια του server επιστρέφει. */
  function takeoverRemoval(e, line) {
    var cfg = readCfg();
    if (!cfg || !cfg.gh || !cfg.tt) return false;
    if (line.getAttribute('data-ptype') !== cfg.tt) return false;
    var key = line.getAttribute('data-key');
    try {
      var fel = document.querySelector('[data-eng-desired]');
      if (fel) {
        var fees = (JSON.parse(fel.textContent).fees || []);
        if (fees.some(function (o) { return o.k === key; })) return false; /* engraved → cart.js fee-batch */
      }
    } catch (err) { /* χωρίς island → συνεχίζουμε */ }
    var gKeys = [];
    var otherParent = false;
    document.querySelectorAll('[data-key][data-ptype]').forEach(function (el) {
      if (el.hidden) return;
      if (el.getAttribute('data-phandle') === cfg.gh || el.getAttribute('data-ptype') === 'guarantee') {
        gKeys.push(el.getAttribute('data-key'));
      } else if (el.getAttribute('data-ptype') === cfg.tt && el.getAttribute('data-key') !== key) {
        otherParent = true;
      }
    });
    if (!gKeys.length || otherParent) return false; /* δεν είναι ο τελευταίος γονέας/χωρίς εγγύηση */
    e.preventDefault();
    e.stopPropagation();
    var updates = {};
    updates[key] = 0;
    gKeys.forEach(function (k) { updates[k] = 0; });
    hideLines(Object.keys(updates)); /* ΟΛΑ μαζί, ΤΩΡΑ — πριν από κάθε δίκτυο */
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates }),
    }).then(function (r) {
      if (!r.ok) throw new Error('update failed');
      if (document.querySelector('.cart-page__items')) { window.location.reload(); return; }
      return refreshDrawer();
    }).catch(function () {
      if (document.querySelector('.cart-page__items')) { window.location.reload(); return; }
      refreshDrawer(); /* fail-open: φρέσκια αλήθεια server, τίποτα κολλημένο-κρυφό */
    });
    return true;
  }

  document.addEventListener('click', function (e) {
    if (disabled) return;
    var ctrl = e.target.closest('[data-remove-line], [data-qty-minus], .cart-page__remove a');
    if (!ctrl) return;
    var line = ctrl.closest('[data-key][data-ptype]');
    if (!line) return;
    if (ctrl.hasAttribute('data-qty-minus')) {
      var inp = line.querySelector('[data-qty-input]');
      if (!inp || (parseInt(inp.value, 10) || 1) > 1) return; /* «−» = αφαίρεση μόνο όταν πέφτει στο 0 */
    }
    if (takeoverRemoval(e, line)) return; /* ΕΝΑ βήμα για όλα */
    parentRemovalInstantHide(line); /* fallback (π.χ. engraved γονέας): τουλάχιστον instant εγγύηση */
  }, true);

  document.addEventListener('change', function (e) {
    if (disabled || !e.target.matches('[data-qty-input]')) return;
    if (parseInt(e.target.value, 10) !== 0) return;
    var line = e.target.closest('[data-key][data-ptype]');
    if (!line) return;
    if (takeoverRemoval(e, line)) return;
    parentRemovalInstantHide(line);
  }, true);

  document.addEventListener('DOMContentLoaded', sync);
  document.addEventListener('cart:updated', sync);
})();
